export default __webpack_public_path__ + "static/media/Bass.033dbdae.mp3";